import { IsNotEmpty, IsEmail, Matches } from 'class-validator';
import { TenantRoleType } from '../../../../viewModels/Enums';
import { FormDataBase } from '@/common/form';

export class UsersFormDataTenantUserInvite extends FormDataBase {

  @IsEmail({}, { message: 'Invalid email address. Valid format is example@mail.com.' })
  @IsNotEmpty({ message: 'Email address is required' })
  email: string = '';

  @Matches(/^[a-zA-Z-' ]{1,50}$/, { message: 'Invalid first name. Valid characters are letters A-Z, \' (apostrophe) and - (hyphen).' })
  @IsNotEmpty({ message: 'First name is required' })
  firstName: string = '';

  @Matches(/^[a-zA-Z-' ]{1,50}$/, { message: 'Invalid last name. Valid characters are letters A-Z, \' (apostrophe) and - (hyphen).' })
  @IsNotEmpty({ message: 'Last name is required' })
  lastName: string = '';

  role: TenantRoleType = TenantRoleType.TenancyAdministrator;

  resetForm(): void {
    this.email = '';
    this.firstName = '';
    this.lastName = '';
    this.role = TenantRoleType.TenancyAdministrator;
  }
}
